import { render, staticRenderFns } from "./Error503.vue?vue&type=template&id=718b5b63&"
import script from "./Error503.vue?vue&type=script&lang=js&"
export * from "./Error503.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports